export const MFA_SMS_CODE_LENGTH = 6;
export const MFA_SMS_CODE_REFRESH_COOLDOWN_SECONDS = 60;
